import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { Tooltip } from '@material-ui/core';
import { BreadcrumbsContext } from '../context/curmbs-context';
import {
  LevelDefaultIcon,
  levelIcon,
} from 'components/grid/grid-hooks/breadcrumbs-hook';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridUpperPanelRoot: {
      minHeight: 60,
      backgroundColor: theme.palette.secondary.main,
      boxShadow: theme.shadows[1],
      alignItems: 'center',
      // maxWidth: '80%',
      //maxHeight: 60,
    },
    breadcrumbs: {
      paddingLeft: theme.spacing() * 2,
      color: 'white',
    },
    link: {
      color: 'white',
      textDecoration: 'none',
      fontSize: '13px !important',
      fontWeight: ('500 !important' as unknown) as 500,
      display: 'flex',
      alignItems: 'center',
    },
    breadcrumbTarget: {
      color: theme.palette.primary.light,
      fontSize: 13,
      fontWeight: 700,
      lineHeight: '60px',
    },
    icon: {
      marginRight: '8px',
    },
    tooltip: {
      fontSize: 12,
    },
  })
);

export function BreadcrumbsPanel() {
  const classes = useStyles();
  const breadcrumbs = useContext(BreadcrumbsContext);
  return (
    <Grid container className={classes.gridUpperPanelRoot}>
      <Grid item xs={12}>
        <Breadcrumbs separator="/" className={classes.breadcrumbs}>
          {breadcrumbs?.map((crumb) => {
            const Icon = levelIcon[crumb.level ?? 'fond'] ?? LevelDefaultIcon;
            return crumb?.to ? (
              <Link to={crumb.to} className={classes.link} key={crumb.node.id}>
                <Tooltip
                  title={
                    <span className={classes.tooltip}>{crumb.levelLabel}</span>
                  }
                  placement="top"
                >
                  <Icon className={classes.icon} fontSize="small" />
                </Tooltip>
                {trimLabel(crumb.label)} {crumb.timeRange}
              </Link>
            ) : (
              <Typography
                className={classes.breadcrumbTarget}
                key={crumb.node.id}
              >
                {trimLabel(crumb.label)} {crumb.timeRange}
              </Typography>
            );
          })}
        </Breadcrumbs>
      </Grid>
    </Grid>
  );
}

export const trimLabel = (label?: string, maxChars = 50): string => {
  if (!label || label.length === 0) {
    return '';
  }
  if (label.length > maxChars) {
    return label.slice(0, maxChars) + '...';
  } else return label;
};
